import { Header } from '../components/Header.js';
import { QuirkIonContent } from '../components/QuirkIonContent.js';
import { QuirkIonPage } from '../components/QuirkIonPage.js';
import { IconArrowBack, IconChatbox } from '../components/QuirkIcons/index.js';
import { IconButton } from '../components/IconButton.js';
import { useHistory } from 'react-router';
import { QuirkVirtualList } from '../components/QuirkVirtualList.js';
import { ConversationItem } from '../components/ConversationItem.js';
import { IonFab, IonFabButton, useIonModal, useIonViewWillEnter } from '@ionic/react';
import { NoResults } from '../components/NoResults.js';
import { SelectUserPopup } from '../components/SelectUserPopup.js';
import { User } from 'model';
import { MessagesState, refreshSummary, setUser } from '../state/messagesSlice.js';
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { ContentPreloader } from '../components/ContentPreloader.js';

export function MessagesPage() {
	const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
	const history = useHistory();
	const [show, dismiss] = useIonModal(SelectUserPopup, {
		onDismiss: () => dismiss(),
		onSelectRecipient: (user: User) => {
			dismiss();
			history.push(`/main/messages/${user._id}`);
		}
	});
	const {
		summary: { conversations, loading }
	} = useSelector((state: { messages: MessagesState }) => state.messages);
	useIonViewWillEnter(() => {
		// clear the conversation user when the view enters
		dispatch(setUser(undefined));
		dispatch(refreshSummary());
	});
	return (
		<QuirkIonPage name="Messages">
			<Header
				title="Direct Messages"
				left={
					<IconButton
						icon={<IconArrowBack />}
						onClick={() => {
							history.goBack();
						}}
					/>
				}
			/>
			<QuirkIonContent flush>
				<>
					{conversations.length === 0 && loading && <ContentPreloader message={'Loading...'} />}
					{conversations.length === 0 && !loading && (
						<NoResults
							heading="No conversations found."
							subheading="Start one now."
							icon={<IconChatbox />}
						/>
					)}
					{conversations.length > 0 && (
						<QuirkVirtualList
							testId="conversation-list"
							items={conversations}
							ItemComponent={ConversationItem}
						/>
					)}
					<div className="ionFabContainer">
						<IonFab vertical="bottom" horizontal="end">
							<IonFabButton
								className="IonFabButton"
								color="secondary"
								onClick={() => show()}
								data-testid="floatingCreateMessageButton"
							>
								<IconChatbox size="large" />
							</IonFabButton>
						</IonFab>
					</div>
				</>
			</QuirkIonContent>
		</QuirkIonPage>
	);
}
